import React from "react";
import { Layers } from "lucide-react";
import PageBanner from "./PageBanner";
import Subunits from "./Subunits";

export default function SubunitsPage() {
  return (
    <div className="min-h-screen bg-[#fafcff]">
      <PageBanner
        title="Our Subunits"
        description="Explore the technical chapters and affinity groups within IEEE ISIMS Student Branch, each driving innovation in their specialized fields."
        Icon={Layers}
      />
      <Subunits />
    </div>
  );
}
